interface GetOptionsFn<T> {
	(): T;
	data?: T;
}

export function getOptionsLazy<T>(getOptions: GetOptionsFn<T>): () => T {
	return () => {
		if (getOptions.data == null) {
			getOptions.data = getOptions();
		}
		return getOptions.data;
	};
}
